import Vue from 'vue'

const state = {
	progress: false,
	base_url: '',
	dialTimeout: 800,
	snackbar: {
		timeout: 6000,
		value: false,
		color: '',
		text: ''
	}
}

const getters = {
	progress: state => state.progress,

	baseUrl: state => state.base_url,

	snackbar: state => state.snackbar
}

const mutations = {
	startProgress: state => {
		state.progress = true
	},

	endProgress: state => {
		state.progress = false
	},

	setBaseUrl: (state, base_url) => {
		state.base_url = base_url
	},

	setSnackbar: (state, snackbar) => {
		state.snackbar = snackbar
	}
}

const actions = {
	SET_FQDN: ({ commit }) => {
		if (process.env.NODE_ENV === 'development') {
			commit('setBaseUrl', 'http://shoptimizer-backend')
		} else {
			commit('setBaseUrl', 'https://api.simonaesimona.it')
			//commit('setBaseUrl', 'https://api-demo.bitmobe.com')
		}
		Vue.axios.defaults.baseURL = state.base_url + '/api'
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
